import {Component, OnInit, Inject, ViewChild} from '@angular/core';
import { PageEvent } from "@angular/material/paginator";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl } from '@angular/forms';

import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';


import { environment } from '../../../environments/environment'
import {Video, FilterVideo, RequestVideo, Download, RequestRU} from '../../models/video'
import { Pagination } from '../../models/host'
import { User, RequestToken } from '../../models/user'
import { OdooService } from '../../services/odoo.service'
import { ApiService } from '../../services/api.service'
import { LogsService } from '../../services/logs.service'

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'es'},
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
  ]
})

export class VideoComponent implements OnInit {
  isInMaintenance:boolean = false;
  isFirstGet:boolean=true;
  showProbresBar: boolean = false
  keyFilter: string = 'Nombre'
  module = "videos"
  breadcrumbs = []
  pageSizes = environment.pageSizes;
  filterAdvanced: boolean = false
  token = ''
  user_id = ''
  color = '#FFFFFF'
  filterVideo: FilterVideo = {
    usePagination: true,
    orderField: 'FechaGrabacion',
    orderDirection: 'DESC',
    pageRecords: 10,
    pageIndex: '1',
    general: '',
    juzgadoCodList: 'ALL',
    useDateFilter: '1',
    lowerDate: '',
    upperDate: '',
    intervinienteNombre: '',
    procesoCod: '',
    etiqueta: '',
    district: '-1',
    area: '-1'
  }
  videos: Video[] = []
  user:RequestToken
  pagination: Pagination = {
    CurrentPage: 0,
    TotalPages: 0,
    StartRow: 0,
    FinalRow: 0,
    TotalRows: 0,
    TotalRowsAll: 0
  }

  ProcedureValue = {
    "id": 0,
    "name": "",
    "type": "secretary",
    "judged": "",
    "judged_id": "",
    "office": "",
    "entity_name": "",
    "specialty_name": "",
    "email": "",
    "name_complete": "",
    "extra_permission": ""
  }
  requestVideo: RequestVideo

  optionsArea: string[] = []
  optionsDistricts : any[] = [];
  optionsJudged: any[] = []
  strJudgedList: string

  disabledDistricts: boolean = true
  disabledJudged: boolean = true

  @ViewChild('areaInput') areaInput;
  @ViewChild('districtInput') districtInput;
  @ViewChild('judgedInput') judgedInput;
  @ViewChild('judgedInput2') judgedInput2;

  constructor(private activeRoute: ActivatedRoute,
              public odooService: OdooService,
              public apiService: ApiService,
              public logService: LogsService,
              private router: Router) {}

  ngOnInit(): void {

    localStorage.removeItem('formTransliterator') // se remueve formTransliterator

    this.activeRoute.params.subscribe(params => {

     //se guardan el token del storage, de los parametros y el id de los parametros

     this.token = params.token;

     this.user_id = params.user_id;

     let data_user_local = JSON.parse(localStorage.getItem('data_user'))
     console.log(data_user_local);
     let diferentToken = false;
     let data_user_local_id = null;

     if(!data_user_local || !data_user_local.hasOwnProperty('id')){
       diferentToken = true;
     }
     else{
      data_user_local_id = data_user_local['id']
      if(data_user_local_id!=this.user_id){
        diferentToken =  true
      }
     }

     console.log('diferenttoken',diferentToken);

     //if(this.user_id != localStorage.getItem('user_id')){ // si el token del storage es diferente al de los parametros
     if(diferentToken){ // si el token del storage es diferente al de los parametros

      console.log('get information');

       this.apiService.getInformationByUserId(this.user_id).subscribe(
         requestUser => { // llama al Odoo

           let requestSave = <RequestRU> requestUser

           if(requestSave.ExecutionStatus && requestSave.ProcedureStatus){ // si la peticion del Odoo es exitosa

             // guarda los procedureValue, y actualiza los token, user id, user y data user
             this.ProcedureValue = requestSave.ProcedureValue;
             localStorage.setItem('token', params.token)
             localStorage.setItem('user_id', params.user_id)
             localStorage.setItem('user', this.ProcedureValue.email)
             localStorage.setItem('data_user', JSON.stringify(this.ProcedureValue))

             //guarda un log de conexion al Odoo
             this.logService.createLog(this.module,
               "Ingreso al aplicativo con userId válido: "+this.user_id).subscribe(
               request =>console.log("ok"),
               error => console.error(error)
             )

             //actualiza los breadcrumbs de inicio
             this.breadcrumbs = [
               {name: 'Inicio', url: '/'+this.token+'/'+params.user_id},
             ]

             if(this.ProcedureValue.type != 'scheduler'){ //si el type del procedure value es diferente de agendador "scheduler"
               if(this.ProcedureValue.extra_permission != "") // y si los permisos extra de los procedure value son diferentes de vacio
               {

                 this.apiService.getJuzgedOtherUser().subscribe(
                   request =>{ //llama a la lista de los juzgados que tienen acceso por user id

                     this.optionsJudged = request;

                     //si la lista de los jugados es mayor a cero
                     if(this.optionsJudged.length > 0)
                     {

                       let arrayJudged: any[] = []
                       let count_judged = 0

                       //guarda los 20 primeros juzgado cod en array judged de la respuesta del servicio
                       for (let judged of this.optionsJudged) {
                         if (arrayJudged.length > 20)
                           break
                         arrayJudged.push(judged.JuzgadoCod)
                       }

                       //convierten dicho array en string, y lo guardan en el storage y en filter videos para filtrar cuales codigos de juzgado son permitiods o no.
                       this.strJudgedList = arrayJudged.join()
                       localStorage.setItem("strJudgedList", this.strJudgedList)
                       this.filterVideo.juzgadoCodList = this.strJudgedList

                       this.disabledJudged = false
                       //quitar get Video
                       //this.getVideo(false) //trae los videos

                     }
                     else { // si los permisos extra de los procedure value son un string vacio ""

                      // guarda en filter video el judged id del procedure value y trae los videos con ese filtro
                      this.filterVideo.juzgadoCodList = this.ProcedureValue.judged_id
                      //quitar get Video
                      //this.getVideo(false)

                    }
                   },
                   error => {

                   }
                 )

               }else { // si los permisos extra de los procedure value son un string vacio ""

                 // guarda en filter video el judged id del procedure value y trae los videos con ese filtro
                 this.filterVideo.juzgadoCodList = this.ProcedureValue.judged_id
                 //quitar get Video
                 //this.getVideo(false)

               }
             }
             else{ //si el type del procedure value es agendador "scheduler"

              //quitar get Video
              //this.getVideo(false) // trea los videos sin filtro

             }
           }
           else
             this.exit() // si la llamada al Odoo no es exitosa
         },
         error => {
               console.log(error);
               localStorage.clear();
               this.exit();
             })
     }
     else{ // si el id del storage es igual al de los parametros y si ambos son diferentes de null

       this.ProcedureValue = JSON.parse(localStorage.getItem('data_user')) // se obteienen los procedures values del storage en data_user
       let lsform = localStorage.getItem('formSearch') // trae los filtros del buscador, es decir paginacion, fecha maxima, fecha minima, etiquetas etc...

       if(lsform !== null){ // si ese filtro del buscador es diferente de null

         let formSearch = JSON.parse(lsform) // lo convieret en Json

         if(this.ProcedureValue.extra_permission !== "") // si los permisos exta son diferentes de string vacio ""
         {

           // trae los filtros de los codigos de juzgado permitidos y los guarda en el filter vidoe jugsgado cod list
           this.strJudgedList = localStorage.getItem("strJudgedList")
           this.filterVideo.juzgadoCodList = this.strJudgedList

           this.apiService.getJuzgedOtherUser().subscribe(
             request =>{ //llama a la lista de los juzgados que tienen acceso por user id

               this.optionsJudged = request;

               //si la lista de juzgados es mayor a cero
               if(this.optionsJudged.length > 0)
               {

                 //configura el filter video para traer los videos dependiendo de la paginacion, la fecha maxima y la fecha minima y depas parametros.
                 this.filterVideo.pageRecords = formSearch.pageRecords
                 this.filterVideo.pageIndex = formSearch.pageIndex

                 if(!formSearch.procesoCod){
                  if (formSearch.useDateFilter === '1')
                  {
                    /* this.filterVideo.upperDate = new Date(formSearch.upperDate)
                    this.filterVideo.lowerDate = new Date(formSearch.lowerDate) */
                    this.filterVideo.upperDate = formSearch.upperDate
                    this.filterVideo.lowerDate = formSearch.lowerDate
                  }else{
                    this.filterVideo.upperDate = formSearch.upperDate
                    this.filterVideo.lowerDate = formSearch.lowerDate
                  }
                 }

                 this.filterVideo.etiqueta = formSearch.etiqueta
                 this.filterVideo.intervinienteNombre = formSearch.intervinienteNombre
                 this.filterVideo.procesoCod = formSearch.procesoCod

                 if(formSearch.useDateFilter === '1' || formSearch.intervinienteNombre !== '' || formSearch.etiqueta)
                   this.filterAdvanced = true

                   //quitar get Video
                 //this.getVideo(true) // una vez configurado el filtro, trae los videos con true

               }
               else{ // si los permisos extra son igual a string vaio ""

                //configura el filter video para traer los videos dependiendo de la paginacion, la fecha maxima y la fecha minima y depas parametros.
                this.filterVideo.pageRecords = formSearch.pageRecords
                this.filterVideo.juzgadoCodList = formSearch.juzgadoCodList
                this.filterVideo.pageIndex = formSearch.pageIndex

                if(!formSearch.procesoCod){
                  if (formSearch.useDateFilter === '1')
                  {
                    /* this.filterVideo.upperDate = new Date(formSearch.upperDate)
                    this.filterVideo.lowerDate = new Date(formSearch.lowerDate) */
                    this.filterVideo.upperDate = formSearch.upperDate
                    this.filterVideo.lowerDate = formSearch.lowerDate
                  }else{
                    this.filterVideo.upperDate = formSearch.upperDate
                    this.filterVideo.lowerDate = formSearch.lowerDate
                  }
                 }

                this.filterVideo.etiqueta = formSearch.etiqueta
                this.filterVideo.intervinienteNombre = formSearch.intervinienteNombre
                this.filterVideo.procesoCod = formSearch.procesoCod

                if(formSearch.useDateFilter === '1' || formSearch.intervinienteNombre !== '' || formSearch.etiqueta)
                  this.filterAdvanced = true

                //quitar get Video
                //this.getVideo(true) // una vez configurado el filtro, trae los videos con true

              }
             },
             error => {

             }
           )
         }else{ // si los permisos extra son igual a string vaio ""

           //configura el filter video para traer los videos dependiendo de la paginacion, la fecha maxima y la fecha minima y depas parametros.
           this.filterVideo.pageRecords = formSearch.pageRecords
           this.filterVideo.juzgadoCodList = formSearch.juzgadoCodList
           this.filterVideo.pageIndex = formSearch.pageIndex

           if(!formSearch.procesoCod){
            if (formSearch.useDateFilter === '1')
            {
              /* this.filterVideo.upperDate = new Date(formSearch.upperDate)
              this.filterVideo.lowerDate = new Date(formSearch.lowerDate) */
              this.filterVideo.upperDate = formSearch.upperDate
              this.filterVideo.lowerDate = formSearch.lowerDate
            }else{
              this.filterVideo.upperDate = formSearch.upperDate
              this.filterVideo.lowerDate = formSearch.lowerDate
            }
           }

           this.filterVideo.etiqueta = formSearch.etiqueta
           this.filterVideo.intervinienteNombre = formSearch.intervinienteNombre
           this.filterVideo.procesoCod = formSearch.procesoCod

           if(formSearch.useDateFilter === '1' || formSearch.intervinienteNombre !== '' || formSearch.etiqueta)
             this.filterAdvanced = true

           //quitar get Video
           //this.getVideo(true) // una vez configurado el filtro, trae los videos con true

         }

       }
       else{ //si ese filtro del buscador es null

         if(this.ProcedureValue.type != 'scheduler'){
           if(this.ProcedureValue.extra_permission !== "") // si el tipo del procedur value es diferente a agendador y si los permisos extra son diferentes de string vacio ""
           {

             this.apiService.getJuzgedOtherUser().subscribe(
               request =>{ // obteine la lista de juzgados

                 this.optionsJudged = request;

                 if(this.optionsJudged.length > 0)
                 { // si la lista es mayor a cero, guarda del storage strJudgedList la lista de los jugados que se permiten o no y se traen los videos
                   this.strJudgedList = localStorage.getItem("strJudgedList")
                   this.filterVideo.juzgadoCodList = this.strJudgedList
                   //quitar get Video
                   //this.getVideo(false)
                 }
                 else{ // si el tipo del procedur value es diferente a agendador y si los permisos extra son string vacio ""
                  //se guarda del procedure value el judged id, y se guada en el filter video para los codigos de juzgado que se permiten o no y se traen los videos
                  this.filterVideo.juzgadoCodList = this.ProcedureValue.judged_id
                  //quitar get Video
                  //this.getVideo(false)
                }

               },
               error => {

               }
             )
           }else{ // si el tipo del procedur value es diferente a agendador y si los permisos extra son string vacio ""
             //se guarda del procedure value el judged id, y se guada en el filter video para los codigos de juzgado que se permiten o no y se traen los videos
             this.filterVideo.juzgadoCodList = this.ProcedureValue.judged_id
             //quitar get Video
             //this.getVideo(false)
           }
         }
       }

       //si los token son diferentes de null ambos, independientemente de como se trageron los videos y sus filtros, se guarda el breadcrumbs actualizado

       this.breadcrumbs = [
        {name: 'Inicio', url: '/'+this.token+'/'+localStorage.getItem('user_id')},
       ]

     }

    })

    this._getFilterArea()

    // this.filteredOptionsDistricts = this.apiService.getDistricts();

  }

  exit(): void{
    this.router.navigate(['/'])
  }

  pageOnChange(event: PageEvent){
    this.showProbresBar = true;
    if(this.filterVideo.pageRecords != event.pageSize){
      this.filterVideo.pageIndex = '1';
      this.filterVideo.pageRecords = event.pageSize;
    }
    else{
      this.filterVideo.pageIndex = String(event.pageIndex + 1);
    }
    this.getVideo(false)
  }

  showFilterAdvanced(): void{
    this.filterAdvanced = !this.filterAdvanced;
  }

  getVideo(init: boolean): void{

    if((this.filterVideo.lowerDate==""||this.filterVideo.upperDate=="") && !this.filterVideo.procesoCod) return

    this.isFirstGet=false;
    this.showProbresBar = true
    this.apiService.getVideos(this.filterVideo, init).subscribe(
      requestVideos => {
        this.requestVideo = requestVideos;
        this.videos = this.requestVideo.Data;
        //this.videos = this.requestVideo['Table2'];
        this.pagination = this.requestVideo.Pagination[0]
        this.showProbresBar = false
      },
      err => {
        console.log(err)
        this.showProbresBar = false
      }
    )
  }

  cleanFilter():void{
    this.filterVideo = {
      usePagination: true,
      orderField: 'FechaGrabacion',
      orderDirection: 'DESC',
      pageRecords: this.filterVideo.pageRecords,
      pageIndex: '1',
      general: '',
      juzgadoCodList: 'ALL',
      useDateFilter: '0',
      lowerDate: '',
      upperDate: '',
      intervinienteNombre: '',
      procesoCod: '',
      etiqueta: '',
      district: '-1',
      area: '-1'
    }
    let formSearch = JSON.parse(localStorage.getItem('formSearch'))
    formSearch['lowerDate']="";
    formSearch['upperDate']="";
    formSearch['procesoCod']="";
    formSearch['intervinienteNombre']="";
    formSearch['etiqueta']="";
    localStorage.setItem('formSearch', JSON.stringify(formSearch))
    if(this.ProcedureValue.type === 'secretary' && this.ProcedureValue.extra_permission !== ''){
      this.filterVideo.juzgadoCodList = this.strJudgedList
      this.judgedInput2.clear()
    }

    else if(this.ProcedureValue.type != 'scheduler' && this.ProcedureValue.extra_permission === '')
      this.filterVideo.juzgadoCodList = this.ProcedureValue.judged_id
    this.optionsDistricts = []

    this.optionsJudged = []
    this.areaInput.clear()
    this.districtInput.clear()
    this.judgedInput.clear()
    this.disabledDistricts = true
    this.disabledJudged = true
    document.body.click();
    //quitar get Video
    //this.getVideo(false)
  }

  private _getFilterArea(): void{
    this.apiService.getArea().subscribe(
      request => {
        this.optionsArea = request;
      },
      error => {
        console.log(error);
      }
    )
  }

  onChangeAreaEvent(val: string){
    this.filterVideo.area = '-1'
    this.filterVideo.district = '-1'
    this.filterVideo.juzgadoCodList = 'ALL'
    this.disabledDistricts = true
    this.disabledJudged = true
    this.districtInput.clear()
    this.judgedInput.clear()
    this.areaInput.clear()
    this.optionsDistricts = []
    this.optionsJudged = []
  }
  onFocusedAreaEvent(e){
    this.filterVideo.area = '-1'
    this.filterVideo.district = '-1'
    this.filterVideo.juzgadoCodList = 'ALL'
    this.disabledDistricts = true
    this.disabledJudged = true
    this.districtInput.clear()
    this.judgedInput.clear()
    this.optionsDistricts = []
    this.optionsJudged = []
  }
  selectAreaEvent(item){
    this.filterVideo.area = item.AreaCod
    this.filterVideo.district = '-1'
    this.districtInput.clear()
    this.judgedInput.clear()
    this.filterVideo.juzgadoCodList = 'ALL'
    this.optionsJudged = []
    this.apiService.getDistricts(this.filterVideo.area).subscribe(
      request =>{
        this.optionsDistricts = request;
        if(this.optionsArea.length > 0)
        {
          this.disabledDistricts = false
          this.disabledJudged = true
        }
        else
        {
          this.disabledDistricts = true
          this.disabledJudged = true
        }
      },
      error => {

      }
    )
    //quitar get Video
    //this.getVideo(false)
  }


  selectDistrictsEvent(item){
    this.filterVideo.district = item.DistritoCod;
    this.filterVideo.juzgadoCodList = 'ALL'
    this.judgedInput.clear()
    this.optionsJudged = []
    this.apiService.getJuzged(this.filterVideo.district, this.filterVideo.area).subscribe(
      request =>{
        this.optionsJudged = request;
        if(this.optionsJudged.length > 0)
        {
          this.disabledJudged = false
        }
      },
      error => {

      }
    )
    //quitar get Video
    //this.getVideo(false)
  }

  onChangeDistrictsEvent(val: string){
    this.filterVideo.district = '-1'
    this.filterVideo.juzgadoCodList = 'ALL'
    this.judgedInput.clear()
    this.optionsJudged = []
    this.disabledJudged = true
  }
  onFocusedDistrictsEvent(e){
    this.filterVideo.district = '-1'
    this.filterVideo.juzgadoCodList = 'ALL'
    this.judgedInput.clear()
    this.optionsJudged = []
    this.disabledJudged = true
    //quitar get Video
    //this.getVideo(false)
  }


  selectJudgedEvent(item){
    this.filterVideo.juzgadoCodList = item.JuzgadoCod
    //quitar get Video
    //this.getVideo(false)
  }

  onFocusedJudgedEvent(e){
    if(this.ProcedureValue.type === 'secretary' && this.ProcedureValue.extra_permission !== ''){
      this.filterVideo.juzgadoCodList = this.strJudgedList
      this.judgedInput2.clear()
    }
    else {
      this.filterVideo.juzgadoCodList = 'ALL'
      //quitar get Video
      //this.getVideo(false)
    }
  }
  onChangeJudgedEvent(val: string){
    this.filterVideo.juzgadoCodList = this.strJudgedList
    this.judgedInput2.clear()
  }


}
